<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>报价列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th width="180px">询价单号</th>
                <th>报价方</th>
                <th class="align-right" width="120px" tyle="text-align: right">报价总金额(元)</th>
                <th width="180px">报价时间</th>
                <th width="120px">询价截止日期</th>
                <th width="100px">是否已采纳</th>
                <th class="align-left" width="260px" v-if="showAction">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td>{{priceReply.inqryVoucherNo}}</td>
                <td class="align-left">{{priceReply.merchantName}}</td>
                <td class="align-right">{{priceReply.replyAmount == null ? '0.00' : priceReply.replyAmount.toFixed(2)}}</td>
                <td>{{priceReply.replyTime}}</td>
                <td>{{expireDate}}</td>
                <td v-if="priceReply.adopted==true">已采纳</td>
                <td v-if="priceReply.adopted==false">未采纳</td>
                <td class="align-left" v-if="showAction">
                    <div>
                        <a class="swb-btn-link" v-if="priceReply.adopted==false" @click="toPriceReplyInfo(priceReply.id, false)">采纳</a>
                        <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id, true)">查看详细信息</a>
                        <a class="swb-btn-link" @click="addQualifiedMerchant(priceReply.merchantId, priceReply.merchantType)">加入备选供方</a>
                        <a class="swb-btn-link" v-if="priceReply.adopted" @click="saveGoodsOrder(priceReply.id)">下订单</a>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <!--<div class="no-data">-->
        <!--<i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>-->
        <!--<span class="">暂无数据 . . .</span>-->
        <!--</div>-->
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import priceApi from '../../api/price'
    import merchtComnApi from '../../api/merchtComn'

    import SwbPriceReplyInfo from './PriceReplyInfo';
    Routes.add(SwbPriceReplyInfo);
    import SwbPriceInpryList from './PriceInpryList';
    Routes.add(SwbPriceInpryList);
    import SwbSaveGoodsOrderForPriceReply from '../order/SaveGoodsOrderForPriceReply';
    Routes.add(SwbSaveGoodsOrderForPriceReply);

    export default{
        name: 'swb-price-reply-list',
        path: '/price/reply/voucher/list',
        pathOld: '/price/reply/list',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        parentBreadcrumbUrl: '/price/inpry/voucher/list',
        customBreadcrumb: false,
        desc: '报价单列表',
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                priceReplyList: [],
                expireDate: null,
                showAction: true
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            self.expireDate = this.$route.query.expireTime;
            let finished = this.$route.query.finished;
            if (finished != undefined) {
                self.showAction = false;
            }
            self.getPriceReplyList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceReplyList();
            },
            getPriceReplyList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.inqryVoucherId = this.$route.query.id;
                //filterItems.tradeType = this.$route.query.tradeType;
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceReplyVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == 'info') {
                        self.priceReplyList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toPriceReplyInfo: function (id, isView) {
                this.$router.push({
                    path: SwbPriceReplyInfo.path,
                    query: {
                        id: id,
                        adopted: true,
                        isView: isView
                    }
                });
            },
            // 加入合格商户
            addQualifiedMerchant: function (merchantId, merchantType) {
                // 为了使用原有的接口，设置数据
                let peerMerchantIds = [];
                peerMerchantIds.add(merchantId);
                //
                let postData = {};
                postData.bizRelIds = peerMerchantIds;
                postData.peerMerchantType = merchantType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.saveMerchantBizRel(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result != null) {
                        if (result.type == 'info') {
                            MsgBox.success(result.message);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
            saveGoodsOrder: function (replyId) {
                this.$router.push({
                    path: SwbSaveGoodsOrderForPriceReply.path,
                    query: {
                        replyId: replyId
                    }
                });
            },
            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbPriceInpryList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceReplyList.vue